const isLocal = false;
export const API_HOST = isLocal ? "http://localhost:8080" : "https://api.tenitx.com";